export const OWNER_TILE_WIDTH = 200;
export const OWNER_RESPONSIVE_LAYOUT_SX = { alignItems: 'center', flexWrap: 'wrap' };
export const OWNER_ITEM_WRAPPER_SX = { display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, maxWidth: '100%' };
